import React, { useState, useEffect, useRef } from 'react'

const VideoDuration = ({ videoUrl, initialDuration }) => {
  const [duration, setDuration] = useState(initialDuration)
  const videoRef = useRef(null)

  useEffect(() => {
    if (!initialDuration && videoUrl) {
      // Create a hidden video element to load metadata
      const video = document.createElement('video')
      video.src = videoUrl
      video.preload = 'metadata'

      const handleLoadedMetadata = () => {
        setDuration(video.duration)
        video.removeEventListener('loadedmetadata', handleLoadedMetadata)
      }

      video.addEventListener('loadedmetadata', handleLoadedMetadata)

      // Cleanup
      return () => {
        video.removeEventListener('loadedmetadata', handleLoadedMetadata)
        video.src = ''
        video.load()
      }
    }
  }, [videoUrl, initialDuration])

  const formatDuration = d => {
    if (!d) return '0:00'
    const minutes = Math.floor(d / 60)
    const seconds = Math.floor(d % 60)
    return `${minutes}:${String(seconds).padStart(2, '0')}`
  }

  return <span>{formatDuration(duration || initialDuration)}</span>
}

export default VideoDuration
